export const defaultLocale = "en";

export const localesList = {
  en: "en",
  ru: "ru",
  ua: "ua",
  az: "az",
  ko: "kr",
  "pt-BR": "br",
  "es-MX": "mx",
} as const;

export const locales = Object.keys(localesList) as Array<keyof typeof localesList>;
export type I18nLocalesType = (typeof locales)[number];

export const localePrefix = {
  mode: "as-needed",
  prefixes: {
    "pt-BR": "/pt",
    "es-MX": "/mx",
    ko: "/kr",
  },
} as const;
